import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import Typography from '@material-ui/core/Typography';

import { Field } from 'redux-form';

import TextField, { TextFieldAdornmentText } from 'components/fields/TextField';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';

const styles = theme => ({
  grid: {
    marginBottom: 10,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 4,
    },
  },
  gridGutter: {
    marginTop: 15,
  },
  typography: {
    paddingBottom: 2,
    borderBottom: `1px solid ${theme.palette.primary.A100}`,
  },
});

const BusinessTwilioCredentialsFieldArray = ({
  fields,
  classes,
}) => (
  <Fragment>
    {fields.map((credentialsType, index) => (
      <Fragment key={index}>
        <Grid
          className={classNames(classes.grid, classes.gridGutter)}
          container
          spacing={24}
        >
          <Grid item xs={12}>
            <Typography className={classes.typography}>
              {fields.get(index)['Twilio Service Type']}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          className={classes.grid}
          container
          spacing={24}
        >
          <Grid item xs={12} md={6}>
            <Field
              id="Twilio Auth Token"
              name={`${credentialsType}.Twilio Auth Token`}
              label="Twilio Auth Token"
              component={TextField}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Field
              id="Twilio Account SID"
              name={`${credentialsType}.Twilio Account SID`}
              label="Twilio Account SID"
              component={TextField}
              fullWidth
            />
          </Grid>
        </Grid>
        <Grid
          className={classes.grid}
          container
          spacing={24}
        >
          <Grid item xs={12} md={6}>
            <Field
              id="Twilio Phone Number"
              label="Phone Number"
              name={`${credentialsType}.Twilio Phone Number`}
              component={TextField}
              validate={[validate.phone]}
              format={value => (value ? value.replace('+1 ', '') : '')}
              normalize={normalize.phone}
              maxLength="14"
              startAdornment={
                <InputAdornment position="start">
                  <TextFieldAdornmentText>
                    +1
                  </TextFieldAdornmentText>
                </InputAdornment>
              }
              fullWidth
            />
          </Grid>
        </Grid>
      </Fragment>
    ))}
  </Fragment>
);

BusinessTwilioCredentialsFieldArray.propTypes = {
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
    gridGutter: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(BusinessTwilioCredentialsFieldArray);



// WEBPACK FOOTER //
// ./src/components/settings/BusinessTwilioCredentialsForm/BusinessTwilioCredentialsFieldArray.js